 const zeroIfEmpty = text => {
    if (!text) return 0;
    if (text === '' || text === undefined) return 0;
    return parseInt(text, 10);
};

const convertToBoolean = value => {
    if (!value) return false;

    if (value.toLowerCase() === 'true') {
        return true;
    }

    return false;
};

const convertToString = value => {
    if (!value) return '';

    return value.toString();
};

const ConfirmAction = strQuestion => {
    if (confirm(strQuestion)) {
        return true;
    }
    return false;
};

const secondsToTime = secs => {
    const days = Math.floor(secs / (60 * 60 * 24));

    const divisorForHours = secs % (60 * 60 * 24);
    const hours = Math.floor(divisorForHours / (60 * 60));

    const divisorForMinutes = secs % (60 * 60);
    const minutes = Math.floor(divisorForMinutes / 60);

    const divisorForSeconds = divisorForMinutes % 60;
    const seconds = Math.ceil(divisorForSeconds);

    const obj = {
        d: days,
        h: hours,
        m: minutes,
        s: seconds
    };
    return obj;
};

const twoDigitNumber =  value => {
    return ('0' + value).slice(-2);
};

const ConvertToPersianDigit = (text): string => {
    if (!text) return '';

    return text.toString()
        .replace(/0/g, '۰')
        .replace(/1/g, '۱')
        .replace(/2/g, '۲')
        .replace(/3/g, '۳')
        .replace(/4/g, '۴')
        .replace(/5/g, '۵')
        .replace(/6/g, '۶')
        .replace(/7/g, '۷')
        .replace(/8/g, '۸')
        .replace(/9/g, '۹');
};

const PopupCenter = (url, title, w, h) => {
    const $screen = screen as any;
    // Fixes dual-screen position                         Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : $screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : $screen.top;

    const width = window.innerWidth ?
        window.innerWidth :
        document.documentElement.clientWidth ?
        document.documentElement.clientWidth :
        screen.width;
    const height = window.innerHeight ?
        window.innerHeight :
        document.documentElement.clientHeight ?
        document.documentElement.clientHeight :
        screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(
        url,
        title,
        'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
    return newWindow;
};

const setCookie = (cname, cvalue, exdays) => {
    if (exdays > 0) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + '; ' + expires;
    } else {
        document.cookie = cname + '=' + cvalue;
    }
};

const getCookie = cname => {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
};

const clearCookie = cname => {
    document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
};

const numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getThousandSeperated = value => {
    const trimmed = value.replace(/[^\d.]/g, '');
    return trimmed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const validateNationalId = value => {
    const regex = new RegExp(/^(?!(\d)\1{9})\d{10}$/);

    if (!regex.test(value)) {
        return false;
    }

    let s = 0;
    const c = parseInt(value.substr(9, 1), 10);

    for (let i = 0; i < 9; i++) {
        s += parseInt(value.substr(i, 1), 10) * (10 - i);
    }

    s = s % 11;

    return ((s < 2 && c === s) || (s >= 2 && c === (11 - s)));
};

const formatPrice = (value: number | string, addToman: boolean = true) => {
    if (!value) {
        value = 0;
    }

    const commaSeparated = numberWithCommas(value);
    const persian = ConvertToPersianDigit(commaSeparated);
    if (addToman) {
        return `${commaSeparated} تومان`;
    }

    return persian;
};

const getParameterByName = (name: string, url: string) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const Utils = {
    zeroIfEmpty,
    ConfirmAction,
    secondsToTime,
    twoDigitNumber,
    ConvertToPersianDigit,
    PopupCenter,
    setCookie,
    getCookie,
    clearCookie,
    numberWithCommas,
    getThousandSeperated,
    validateNationalId,
    formatPrice,
    convertToBoolean,
    convertToString,
    getParameterByName
};

export default Utils;
